package io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.Icons

public val Icons.GogdotcomSimpleIcons: ImageVector
    get() {
        if (_gogdotcomSimpleIcons != null) {
            return _gogdotcomSimpleIcons!!
        }
        _gogdotcomSimpleIcons = Builder(name = "GogdotcomSimpleIcons", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 24.0f, viewportHeight = 24.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(7.15f, 15.24f)
                horizontalLineTo(4.36f)
                arcToRelative(0.4f, 0.4f, 0.0f, false, false, -0.4f, 0.4f)
                verticalLineToRelative(2.0f)
                curveToRelative(0.0f, 0.21f, 0.18f, 0.4f, 0.4f, 0.4f)
                horizontalLineToRelative(2.8f)
                verticalLineToRelative(1.32f)
                horizontalLineToRelative(-3.5f)
                curveToRelative(-0.56f, 0.0f, -1.02f, -0.46f, -1.02f, -1.03f)
                verticalLineToRelative(-3.39f)
                curveToRelative(0.0f, -0.56f, 0.46f, -1.02f, 1.03f, -1.02f)
                horizontalLineToRelative(3.48f)
                verticalLineToRelative(1.32f)
                close()
                moveTo(8.16f, 11.54f)
                curveToRelative(0.0f, 0.58f, -0.47f, 1.05f, -1.05f, 1.05f)
                horizontalLineTo(2.63f)
                verticalLineToRelative(-1.35f)
                horizontalLineToRelative(3.78f)
                arcToRelative(0.4f, 0.4f, 0.0f, false, false, 0.4f, -0.4f)
                verticalLineTo(6.39f)
                arcToRelative(0.4f, 0.4f, 0.0f, false, false, -0.4f, -0.4f)
                horizontalLineTo(4.39f)
                arcToRelative(0.4f, 0.4f, 0.0f, false, false, -0.41f, 0.4f)
                verticalLineToRelative(2.02f)
                curveToRelative(0.0f, 0.23f, 0.18f, 0.4f, 0.4f, 0.4f)
                horizontalLineTo(6.0f)
                verticalLineToRelative(1.35f)
                horizontalLineTo(3.68f)
                curveToRelative(-0.58f, 0.0f, -1.05f, -0.46f, -1.05f, -1.04f)
                verticalLineTo(5.68f)
                curveToRelative(0.0f, -0.57f, 0.47f, -1.04f, 1.05f, -1.04f)
                horizontalLineTo(7.1f)
                curveToRelative(0.58f, 0.0f, 1.05f, 0.47f, 1.05f, 1.04f)
                verticalLineToRelative(5.86f)
                close()
                moveTo(21.36f, 19.36f)
                horizontalLineToRelative(-1.32f)
                verticalLineToRelative(-4.12f)
                horizontalLineToRelative(-0.93f)
                arcToRelative(0.4f, 0.4f, 0.0f, false, false, -0.4f, 0.4f)
                verticalLineToRelative(3.72f)
                horizontalLineToRelative(-1.33f)
                verticalLineToRelative(-4.12f)
                horizontalLineToRelative(-0.93f)
                arcToRelative(0.4f, 0.4f, 0.0f, false, false, -0.4f, 0.4f)
                verticalLineToRelative(3.72f)
                horizontalLineToRelative(-1.33f)
                verticalLineToRelative(-4.42f)
                curveToRelative(0.0f, -0.56f, 0.46f, -1.02f, 1.03f, -1.02f)
                horizontalLineToRelative(5.61f)
                verticalLineToRelative(5.44f)
                close()
                moveTo(21.37f, 11.54f)
                curveToRelative(0.0f, 0.58f, -0.47f, 1.05f, -1.05f, 1.05f)
                horizontalLineToRelative(-4.48f)
                verticalLineToRelative(-1.35f)
                horizontalLineToRelative(3.78f)
                arcToRelative(0.4f, 0.4f, 0.0f, false, false, 0.4f, -0.4f)
                verticalLineTo(6.39f)
                arcToRelative(0.4f, 0.4f, 0.0f, false, false, -0.4f, -0.4f)
                horizontalLineToRelative(-2.03f)
                arcToRelative(0.4f, 0.4f, 0.0f, false, false, -0.4f, 0.4f)
                verticalLineToRelative(2.02f)
                curveToRelative(0.0f, 0.23f, 0.18f, 0.4f, 0.4f, 0.4f)
                horizontalLineToRelative(1.62f)
                verticalLineToRelative(1.35f)
                horizontalLineTo(16.9f)
                curveToRelative(-0.58f, 0.0f, -1.05f, -0.46f, -1.05f, -1.04f)
                verticalLineTo(5.68f)
                curveToRelative(0.0f, -0.57f, 0.47f, -1.04f, 1.05f, -1.04f)
                horizontalLineToRelative(3.43f)
                curveToRelative(0.58f, 0.0f, 1.05f, 0.47f, 1.05f, 1.04f)
                verticalLineToRelative(5.86f)
                close()
                moveTo(13.72f, 4.64f)
                horizontalLineToRelative(-3.44f)
                curveToRelative(-0.58f, 0.0f, -1.04f, 0.47f, -1.04f, 1.04f)
                verticalLineToRelative(3.44f)
                curveToRelative(0.0f, 0.58f, 0.46f, 1.04f, 1.04f, 1.04f)
                horizontalLineToRelative(3.44f)
                curveToRelative(0.57f, 0.0f, 1.04f, -0.46f, 1.04f, -1.04f)
                verticalLineTo(5.68f)
                curveToRelative(0.0f, -0.57f, -0.47f, -1.04f, -1.04f, -1.04f)
                moveToRelative(-0.3f, 1.75f)
                verticalLineToRelative(2.02f)
                arcToRelative(0.4f, 0.4f, 0.0f, false, true, -0.4f, 0.4f)
                horizontalLineToRelative(-2.03f)
                arcToRelative(0.4f, 0.4f, 0.0f, false, true, -0.4f, -0.4f)
                verticalLineTo(6.4f)
                curveToRelative(0.0f, -0.22f, 0.17f, -0.4f, 0.4f, -0.4f)
                horizontalLineTo(13.0f)
                curveToRelative(0.23f, 0.0f, 0.4f, 0.18f, 0.4f, 0.4f)
                close()
                moveTo(12.63f, 13.92f)
                horizontalLineTo(9.24f)
                curveToRelative(-0.57f, 0.0f, -1.03f, 0.46f, -1.03f, 1.02f)
                verticalLineToRelative(3.39f)
                curveToRelative(0.0f, 0.57f, 0.46f, 1.03f, 1.03f, 1.03f)
                horizontalLineToRelative(3.39f)
                curveToRelative(0.57f, 0.0f, 1.03f, -0.46f, 1.03f, -1.03f)
                verticalLineToRelative(-3.39f)
                curveToRelative(0.0f, -0.56f, -0.46f, -1.02f, -1.03f, -1.02f)
                moveToRelative(-0.3f, 1.72f)
                verticalLineToRelative(2.0f)
                arcToRelative(0.4f, 0.4f, 0.0f, false, true, -0.4f, 0.4f)
                verticalLineToRelative(-0.01f)
                horizontalLineTo(9.94f)
                arcToRelative(0.4f, 0.4f, 0.0f, false, true, -0.4f, -0.4f)
                verticalLineToRelative(-1.99f)
                curveToRelative(0.0f, -0.22f, 0.18f, -0.4f, 0.4f, -0.4f)
                horizontalLineToRelative(2.0f)
                curveToRelative(0.22f, 0.0f, 0.4f, 0.18f, 0.4f, 0.4f)
                close()
                moveTo(23.49f, 1.1f)
                arcToRelative(1.74f, 1.74f, 0.0f, false, false, -1.24f, -0.52f)
                horizontalLineTo(1.75f)
                arcTo(1.74f, 1.74f, 0.0f, false, false, 0.0f, 2.33f)
                verticalLineToRelative(19.34f)
                arcToRelative(1.74f, 1.74f, 0.0f, false, false, 1.75f, 1.75f)
                horizontalLineToRelative(20.5f)
                arcTo(1.74f, 1.74f, 0.0f, false, false, 24.0f, 21.67f)
                verticalLineTo(2.33f)
                curveToRelative(0.0f, -0.48f, -0.2f, -0.92f, -0.51f, -1.24f)
                moveToRelative(0.0f, 20.58f)
                arcToRelative(1.23f, 1.23f, 0.0f, false, true, -1.24f, 1.24f)
                horizontalLineTo(1.75f)
                arcTo(1.23f, 1.23f, 0.0f, false, true, 0.5f, 21.67f)
                verticalLineTo(2.33f)
                arcToRelative(1.23f, 1.23f, 0.0f, false, true, 1.24f, -1.24f)
                horizontalLineToRelative(20.5f)
                arcToRelative(1.24f, 1.24f, 0.0f, false, true, 1.24f, 1.24f)
                verticalLineToRelative(19.34f)
                close()
            }
        }
        .build()
        return _gogdotcomSimpleIcons!!
    }

private var _gogdotcomSimpleIcons: ImageVector? = null
